import React from "react";
import AddConnectorContainer from "containers/ConnectorType/Addconnector/index";

const AddConnectorPage = () => {
  return (
    <>
    
      <AddConnectorContainer />
    </>
  );
};

export default AddConnectorPage;